import React from 'react';
import {Typography, TypographyProps} from '@mui/material';
import {formatSecondsToTime} from 'models';
export interface AppTimerCounterTypographyProps extends Omit<TypographyProps, 'children'> {
    counterValueInSeconds?: number;
}
export const AppTimerCounterTypography: React.FC<AppTimerCounterTypographyProps> = ({
    counterValueInSeconds = 0,
    ...rest
}) => {
    // Check if text needs to be truncated

    // Truncate text if necessary

    return (
        <Typography {...rest}>
            {counterValueInSeconds === 0 ? '00:00:00' : formatSecondsToTime(counterValueInSeconds)}
        </Typography>
    );
};
export default AppTimerCounterTypography;
